import React from 'react';
import { ShoppingBagIcon, CoffeeIcon, HomeIcon, CarIcon, SmartphoneIcon, CreditCardIcon, CalendarIcon, RepeatIcon, BoxIcon } from 'lucide-react';
export function TransactionList() {
  const transactions = [{
    id: 1,
    name: 'Amazon',
    category: 'Shopping',
    icon: ShoppingBagIcon,
    iconBg: 'bg-blue-100',
    iconColor: 'text-blue-600',
    amount: -82.99,
    date: 'Today',
    time: '14:30',
    paymentMethod: {
      type: 'card',
      name: 'Visa ending in 4539',
      icon: CreditCardIcon,
      iconColor: 'text-blue-600'
    }
  }, {
    id: 2,
    name: 'Starbucks',
    category: 'Food & Drink',
    icon: CoffeeIcon,
    iconBg: 'bg-green-100',
    iconColor: 'text-green-600',
    amount: -4.5,
    date: 'Today',
    time: '09:15',
    paymentMethod: {
      type: 'mobile',
      name: 'Apple Pay',
      logo: 'https://logo.clearbit.com/apple.com'
    }
  }, {
    id: 3,
    name: 'Rent Payment',
    category: 'Housing',
    icon: HomeIcon,
    iconBg: 'bg-purple-100',
    iconColor: 'text-purple-600',
    amount: -1200.0,
    date: 'Yesterday',
    time: '00:00',
    paymentMethod: {
      type: 'direct-debit',
      name: 'Direct Debit',
      icon: RepeatIcon,
      iconColor: 'text-gray-600'
    }
  }, {
    id: 4,
    name: 'Uber',
    category: 'Transport',
    icon: CarIcon,
    iconBg: 'bg-yellow-100',
    iconColor: 'text-yellow-600',
    amount: -12.8,
    date: 'Yesterday',
    time: '19:42',
    paymentMethod: {
      type: 'mobile',
      name: 'Google Pay',
      logo: 'https://logo.clearbit.com/google.com'
    }
  }, {
    id: 5,
    name: 'Vodafone',
    category: 'Bills',
    icon: SmartphoneIcon,
    iconBg: 'bg-red-100',
    iconColor: 'text-red-600',
    amount: -35.0,
    date: '20 May',
    time: '00:00',
    paymentMethod: {
      type: 'bank-transfer',
      name: 'Open Banking',
      icon: BoxIcon,
      iconColor: 'text-primary'
    }
  }];
  // Function to render payment method
  const renderPaymentMethod = method => {
    if (method.type === 'mobile') {
      return <div className="flex items-center" data-id="element-767">
          <img src={method.logo} alt={method.name} className="w-4 h-4 mr-1 object-contain" onError={e => {
          e.currentTarget.src = `https://via.placeholder.com/16/754acd/FFFFFF?text=${method.name.charAt(0)}`;
        }} data-id="element-768" />
          <span data-id="element-769">{method.name}</span>
        </div>;
    } else {
      return <div className="flex items-center" data-id="element-770">
          <method.icon className={`w-4 h-4 mr-1 ${method.iconColor}`} data-id="element-771" />
          <span data-id="element-772">{method.name}</span>
        </div>;
    }
  };
  return <div className="bg-card rounded-xl shadow-sm" data-id="element-773">
      <div className="p-4 border-b border-gray-100" data-id="element-774">
        <div className="flex justify-between items-center" data-id="element-775">
          <h2 className="text-lg font-semibold text-text-primary" data-id="element-776">
            Recent Transactions
          </h2>
          <button className="text-primary text-sm font-medium" data-id="element-777">See All</button>
        </div>
      </div>
      <div className="divide-y divide-gray-100" data-id="element-778">
        {transactions.map(transaction => <div key={transaction.id} className="p-4 flex items-center justify-between hover:bg-gray-50" data-id="element-779">
            <div className="flex items-center" data-id="element-780">
              <div className={`w-10 h-10 rounded-full ${transaction.iconBg} flex items-center justify-center mr-3`} data-id="element-781">
                <transaction.icon className={`w-5 h-5 ${transaction.iconColor}`} data-id="element-782" />
              </div>
              <div data-id="element-783">
                <p className="font-medium text-text-primary" data-id="element-784">
                  {transaction.name}
                </p>
                <p className="text-xs text-text-muted" data-id="element-785">
                  {transaction.category}
                </p>
              </div>
            </div>
            <div className="text-right" data-id="element-786">
              <p className={`font-medium ${transaction.amount < 0 ? 'text-text-primary' : 'text-green-600'}`} data-id="element-787">
                {transaction.amount < 0 ? '-' : '+'}£
                {Math.abs(transaction.amount).toFixed(2)}
              </p>
              <div className="flex items-center justify-end text-xs text-text-muted" data-id="element-788">
                <CalendarIcon className="w-3 h-3 mr-1" data-id="element-789" />
                <span data-id="element-790">
                  {transaction.date} • {transaction.time}
                </span>
              </div>
              <div className="text-xs text-text-muted mt-1" data-id="element-791">
                {renderPaymentMethod(transaction.paymentMethod)}
              </div>
            </div>
          </div>)}
      </div>
    </div>;
}